import {
  newAxios
} from './index'

export function Req_GetMenuList(data) {
  return newAxios({
    url: `/i/tenant/system/menu/config/list`,
    data
  })()
}



// WEBPACK FOOTER //
// ./src/request/menu.js